<template>
  <div class="social-box">
    <div class="banner-box">
      <img src="./../assets/img/banner_social.png" alt="">
      <ul class="nav-list-box">
        <li v-for="item in nav" :key="item.id" :class="{active:id==item.id}" @click="updata(item.id)">
          {{item.text}}
        </li>
      </ul>
    </div>
    <div class="social-cont">
      <div class="social-title">{{socialdata.title}}</div>
      <div class="social-info">
        <p v-html="socialdata.info"></p>
      </div>
      <ul class="social-list">
        <li v-for="(item,index) in socialdata.list" :key="index" @click="showfn(index)">
          <div class="social-list-top">
            <img :src="item.icon" alt="">
            <div class="social-top-right">
              <p class="social-top-title">{{item.title}}</p>
              <p class="social-top-info">{{item.info}}</p>
            </div>
            <img :src="jticon" alt="" class="jt" :class="{active:isshownumber==index}">
          </div>

          <div class="social-list-bottom" v-show="isshownumber==index">
            <div v-for="(value,key,i) in item.pic" :key="i">
              <div class="cont-title">{{key}}</div>
              <div class="cont-value" v-html="value"></div>
            </div>
          </div>
        </li>
        <li v-if="id==1">

          <div class="social-list-top" @click="showfn(social[1].list.length)">
            <img :src="list1.icon" alt="">
            <div class="social-top-right">
              <p class="social-top-title">{{list1.title}}</p>
              <p class="social-top-info">{{list1.info}}</p>
            </div>
            <img :src="jticon" alt="" class="jt" :class="{active:isshownumber==social[1].list.length}">
          </div>
          <ul class="social-list1-bottom" v-show="isshownumber==social[1].list.length">
            <li v-for="(value,key,i) in list1.pic" :key="i" @click="list1fn(i)">
              <div class="list-1-title">
                <span>{{key}}</span>
                <img :src="jticon" alt="" :class="{active:islist1==i}">
              </div>
              <div class="list-1-cont" v-show="islist1==i">
                  <img :src="value" alt="">
              </div>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
// 社会单位
import icon1 from "./../assets/img/shdw/icon_1.png";
import icon2 from "./../assets/img/shdw/icon_2.png";
import icon3 from "./../assets/img/shdw/icon_3.png";
import icon4 from "./../assets/img/shdw/icon_4.png";
import icon5 from "./../assets/img/shdw/icon_5.png";
import icon6 from "./../assets/img/shdw/icon_6.png";

import img1 from "./../assets/img/shdw/1.png";
import img2 from "./../assets/img/shdw/2.png";
import img3 from "./../assets/img/shdw/3.png";
import img4 from "./../assets/img/shdw/4.png";
import img5 from "./../assets/img/shdw/5.png";

import img11 from "./../assets/img/shdw/1_1.png";
import img12 from "./../assets/img/shdw/1_2.png";
import img13 from "./../assets/img/shdw/1_3.png";
import img14 from "./../assets/img/shdw/1_4.png";
import img15 from "./../assets/img/shdw/1_5.png";


import jt from "./../assets/img/jt.png";

// 消防监督

import icon11 from "./../assets/img/xfjd/icon_1.png";
import icon12 from "./../assets/img/xfjd/icon_2.png";

import img21 from "./../assets/img/xfjd/1.png";
import img22 from "./../assets/img/xfjd/2.png";
import img23 from "./../assets/img/xfjd/3.png";
// 消防中介

import icon31 from "./../assets/img/xfzj/icon_1.png";
import icon32 from "./../assets/img/xfzj/icon_2.png";
import img31 from "./../assets/img/xfzj/1.png";
import img32 from "./../assets/img/xfzj/2.png";
import img33 from "./../assets/img/xfzj/3.png";


export default {
  name: "social",
  computed: {
    socialdata() {
      return this.social[this.id];
    }
  },
  data() {
    return {
      id: 1,
      jticon: jt,
      isshownumber: -1,
      islist1: -1,
      nav: [
        {
          id: 1,
          text: "社会单位"
        },
        {
          id: 2,
          text: "消防监督部门"
        },
        {
          id: 3,
          text: "消防中介服务机构"
        }
      ],
      list1: {
        icon: icon6,
        title: "智能硬件产品",
        info: "支持NB-IOT、LoRa多种窄带物联网协议和GPRS传输协议。",
        pic: {
          无线电气火灾监控: img11,
          无线火灾报警: img12,
          无线可燃气体: img13,
          物联网: img14,
          AI智能摄像机: img15
        }
      },
      social: {
        1: {
          title: "社会单位解决方案",
          info:
            "帮助法人和实际控制人传递落实消防安全管理责任，避免刑事处罚。<br> 帮助内部管理，监督消防维护企业、物业、保安员和各个部门的日常消防工作。",
          list: [
            {
              icon: icon1,
              title: "单位防火巡查系统",
              info: "确保巡查人员按照国家标准实地检查消防设施，提高管理效率。",
              pic: {
                系统运行过程: '<img src="' + img1 + '">',
                系统优势:
                  '<div class="cont-cont"><h3>网络适应性强</h3><p>不需要插入SIM卡，支持无网操作（登录和提交结果除外）。</p></div><div class="cont-cont"><h3>操作规范 </h3><p>巡查按照国标设计，能设置日周月巡查频次，能自动生成符合国标的巡查记录。 合国标的巡查记录。</p></div><div class="cont-cont"><h3> 支持多部门协同工作 </h3><p> 能按照部门设置人员的分组。</p> </div>'
              }
            },
            {
              icon: icon2,
              title: "单位消防设施维护系统",
              info: "监控维护单位认真履行合同，传递落实安全责任。",
              pic: {
                系统运行过程: '<img src="' + img2 + '">',
                系统优势:
                  '<div class="cont-cont">—能全面监控维护过程是否异常，避免偷工减料。</div><div class="cont-cont">—能自动汇总设施测试故障，跟踪处理结果。</div><div class="cont-cont">—能自动汇总报告，符合消防监督部门检查要求。</div>'
              }
            },
            {
              icon: icon3,
              title: "AI智能摄像机系统",
              info: "第一时间发现异常告警，提升风险预警能力。",
              pic: {
                系统运行过程: '<img src="' + img3 + '">',
                系统优势:
                  '<div class="cont-cont"><h3>高精度</h3><p>AI人工智能图像和音频分析技术，保障检测准确可靠。   </p></div><div class="cont-cont"><h3> 全年无休 </h3><p> 采用AI摄像机，24小时自动检测各种违规事件。  </p> </div><div class="cont-cont"><h3>使用灵活</h3><p>可加装智能视频分析器，连接已有安防摄像头，避免重复投资。   </p></div>'
              }
            },
            {
              icon: icon4,
              title: "单位火灾隐患排查系统",
              info: "实现火灾隐患排查整改一体化，节省时间成本。",
              pic: {
                系统运行过程: '<img src="' + img4 + '">',
                系统优势:
                  '<div class="cont-cont">—能兼容所有通过3C认证的远程监控装置。</div><div class="cont-cont">—能自动调取附近的安防摄像头作火警验证。 </div><div class="cont-cont">—能自动识别报警位置信息。 </div><div class="cont-cont">—能自动推送火警给值班员微信号，核实上报。 </div><div class="cont-cont">—能自动推送设施故障信息给物业维护人员  ，跟踪故障处理。 </div>'
              }
            },
            {
              icon: icon5,
              title: "消防物联网系统",
              info: "强化火警和故障处理能力，减轻消防管理压力。",
              pic: {
                系统运行过程: '<img src="' + img5 + '">',
                系统优势:
                  '<div class="cont-cont">—不需要粘贴标签，使用灵活。     </div><div class="cont-cont">—解决传统手工记录多人操作，汇总困难的问题。     </div><div class="cont-cont">—解决排查和整改的对应难问题，能追溯排查的隐患处理结果。     </div><div class="cont-cont">—支持自动汇总成可编辑的隐患整改记录，减轻日常工作负担。    </div>'
              }
            }
          ]
        },
        2: {
          title:'消防监督部门解决方案',
          info:'全程追溯消防维护企业的工作过程，提供处罚依据。<br>摸清辖区安全重点单位消防设施现状，提供监督依据。',
          list:[
            {
              icon: icon11,
              title: "消防监督检查管理系统",
              info: "解决编制有限，无法全面覆盖监管对象的难题，提高监管效能。",
              pic: {
                系统展示: '<img src="' + img21 + '">',
                系统功能:
                  '<div class="cont-cont">—能管理消防服务行业基本信息，包括技术服务机构人员资质。</div><div class="cont-cont">—全覆盖辖区所有消防重点安全单位的维保过程管理，做到“底数清，情况明”。</div><div class="cont-cont">—多维度统计分析，找出重点监督对象。能追溯现场工作记录，作为消防监督部门执法依据。</div><div class="cont-cont">—支持总队-支队-大队的分级管理。</div>'
              }
            },
             {
              icon: icon12,
              title: "消防监督员现场工作系统",
              info: "通过数据实时共享，打通检查整改上下游。",
              pic: {
                系统展示: '<img src="' + img22 + '" style="margin-bottom:.2rem;width:50%"> <img style="width:50%" src="' + img23 + '">',
                系统功能:
                  '<div class="cont-cont">—支持无网络信号操作（登录和提交结果时除外），避免后续费用。</div><div class="cont-cont">—支持总队-支队-大队的分级管理。</div><div class="cont-cont">—支持消防监督员分组工作，能灵活调整辖区单位。</div><div class="cont-cont">—按照公安部关于修改《消防监督检查规定》的决定（公安部令第120号），预置监督检查规程。     </div><div class="cont-cont">—能追溯火灾隐患处理结果。     </div>'
              }
            },
          ]
        },
        3:{
          title:'消防中介服务机构解决方案',
          info:'     帮助监督外场维护人员的工作，杜绝干私活。<br>帮助管理项目和自动汇总项目报告，节省人工成本。',
          list:[
            {
              icon:icon31,
              title:'消防技术服务管理系统',
              info:'自动满足项目执业合规性，减少人工费用支出。',
              pic:{
                '系统展示':'<img src="' + img31 + '" >',
                '系统运行过程':'<img src="' + img32 + '" >'
              }
            },
            {
              icon:icon32,
              title:'消防设施现场维护管理系统',
              info:'提高人员工作饱和度，创造更多利润。',
              pic:{
                '系统展示':'<img src="' + img33 + '" >',
                '系统运行过程':'<div class="cont-cont">—能接收消防中介服务机构下发的消防检测维保计划， 以及排查和测试任务。</div><div class="cont-cont">—能按照消防系统维护管理的技术规范和消防检测维 保计划，列出消防设施的测试步骤，傻瓜式流程指 导现场维保人员完成任务。</div><div class="cont-cont">—上传的现场照片不能从已有相册中选取，照片上会 自动加上拍摄时的日期和时间水印。</div><div class="cont-cont">—能提供文字、拍照、录音和录像多种手段记录现场 工作过程。文字描述能从系统提供的列表中选择对应 设施的常见故障，减轻工作负担。</div><div class="cont-cont">—能查询已提交的检测维保任务的过程信息。</div>'
              }
            }
          ]
        }
      }
    };
  },
  methods: {
    showfn(index) {
      this.isshownumber = this.isshownumber == index ? -1 : index;
    },
    list1fn(i){
      this.islist1=this.islist1 == i ? -1 : i;
    },
    updata(i){
      this.id=i;
      this.isshownumber=-1;
      this.islist1=-1;
    }
  }
};
</script>
<style lang="scss">
.social-box {
  .social-cont {
    padding: 0 $padding;
    .social-title {
      font-size: 0.3rem;
      margin: 0.3rem 0;
      text-align: center;
    }
    .social-info {
      padding: 0.6rem 0;
      border: 0.04rem solid rgba(0, 0, 0, 0.08);
      line-height: 2;
      @extend .radius;
      margin-bottom: 0.64rem;
      p {
        padding: 0 0.26rem;
        border-left: 0.04rem solid $backBg;
        margin-left: -0.04rem;
      }
    }
    .social-list {
      >li {
        margin-bottom: 0.12rem;
        border: 0.04rem solid #f6f5f5;

        position: relative;

        @extend .radius;
        .social-list-top {
          @extend .flex;
          align-items: center;
          padding: $padding;
          position: relative;
          img {
            width: 0.58rem;
            margin-right: 0.33rem;
          }
          .jt {
            position: absolute;
            left: 50%;
            bottom: 0.05rem;
            transform: translateX(-50%);
            width: 0.33rem;
            &.active {
              transform: translateX(-50%) rotate(-180deg);
            }
          }
          .social-top-info {
            color: #777;
            font-size: 0.24rem;
            line-height: 2;
            margin-top: 0.2rem;
          }
        }
        .social-list-bottom {
          background: #f6f5f5;
          padding: 0 $padding;
          text-align: center;
          img {
            max-width: 100%;
            width:100%;
          }
          .cont-title {
            @include lineheight(1.4rem);
            text-align: center;
          }
          .cont-cont {
            font-size: 0.24rem;
            padding: $padding;
            line-height: 2;
            text-align: left;
            h3 {
              font-size: 0.24rem;
              
            }
          }
        }
        .social-list1-bottom {
          background: #f6f5f5;
          img {
            max-width: 100%;
          }
          .list-1-title {
            @extend .flex;
            justify-content: space-between;
            align-items: center;
            height: 1rem;
            background: #fff;
            border-top:.04rem solid #f6f5f5;
            padding:0 $padding*2;
            img {
              width: 0.33rem;
              &.active{
                transform: rotate(-180deg);
              }
            }
          }
          .list-1-cont{
            padding:$padding $padding*2;
          }
        }
      }
    }
  }
}
</style>
